import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PendingVerifications.css";

const API_ROOT          = (process.env.REACT_APP_API_URL          || "").replace(/\/$/, "");
const LEGACY_PORTAL_BASE = (process.env.REACT_APP_LEGACY_PORTAL_BASE || "http://127.0.0.1").replace(/\/$/, "");
const ALLOWED_MODULES   = [2, 4, 9, 15];

function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return "";
  return d.toLocaleDateString("en-GB");
}

function hfDayLabel(val) {
  if (val === "F") return "First Half";
  if (val === "S") return "Second Half";
  return "Full Day";
}

export default function LeaveDetailsOffice() {
  const navigate = useNavigate();

  const localUser = useMemo(() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);
  const deptId   = parseInt(localUser?.deptid,   10);
  const empId    = parseInt(localUser?.id,        10);

  const [list,    setList]    = useState([]);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");

  const fetchList = async () => {
    setLoading(true);
    setError("");
    try {
      const params = new URLSearchParams({ moduleId });
      if ([2, 15].includes(moduleId)) params.append("deptId", deptId);
      if (moduleId === 9)             params.append("empId",  empId);

      const res  = await fetch(`${API_ROOT}/api/employees/leave-details-office?${params}`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to load leave records");
      setList(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      setError(err.message || "Failed to load leave records");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!ALLOWED_MODULES.includes(moduleId)) return;
    fetchList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleId]);

  const printLeaveOrder = (leaveId) => {
    const form  = document.createElement("form");
    form.method = "POST";
    form.action = `${LEGACY_PORTAL_BASE}/LeaveMgmt/AjaxLeaveOrderPrint.php`;
    form.target = "_blank";
    const input  = document.createElement("input");
    input.type   = "hidden";
    input.name   = "LeaveID";
    input.value  = leaveId;
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  const showDepttAbb = [4, 9].includes(moduleId);
  const showPrint    = moduleId === 9;

  if (!ALLOWED_MODULES.includes(moduleId)) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-3">
      <div className="d-flex align-items-center mb-3 gap-2">
        <h3 className="ctitle mb-0">Leave Details</h3>
        <button
          className="btn btn-primary btn-sm ms-3"
          onClick={() => navigate("/leave-by-office-new")}
        >
          New Leave
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {loading ? (
        <div className="text-muted">Loading...</div>
      ) : list.length === 0 ? (
        <div className="alert alert-info">No leave records found.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm align-middle pending-verif-table">
            <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
              <tr>
                <th>SNo</th>
                {showDepttAbb && <th>Dept</th>}
                <th>Employee</th>
                <th>Mobile</th>
                <th>Entered By</th>
                <th>Leave Type</th>
                <th>From</th>
                <th>To</th>
                <th>Days</th>
                <th>Duration</th>
                <th className="remarks-cell">Remarks</th>
                <th>Status</th>
                {showPrint && <th>Print</th>}
              </tr>
            </thead>
            <tbody>
              {list.map((row, idx) => (
                <tr key={row.LeaveID ?? idx}>
                  <td>{idx + 1}</td>
                  {showDepttAbb && <td>{row.DepttAbb}</td>}
                  <td>{row.EmpName}</td>
                  <td>{row.Mobile}</td>
                  <td>{row.EntryByName}</td>
                  <td>{row.LeaveType}</td>
                  <td>{formatDate(row.FromDate)}</td>
                  <td>{formatDate(row.ToDate)}</td>
                  <td>{row.NoOfDays}</td>
                  <td>{hfDayLabel(row.HFDay)}</td>
                  <td className="remarks-cell">{row.Remarks}</td>
                  <td>{row.Status}</td>
                  {showPrint && (
                    <td>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => printLeaveOrder(row.LeaveID)}
                      >
                        Print
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
